const navtoggle = document.querySelector(".navigation__toggle");
const navigation = document.querySelector(".navigation");

// click on
navtoggle.addEventListener("click", (e) => {
	navtoggle.classList.toggle("on");
	navigation.classList.toggle("on");
	e.preventDefault();
});

// click off
document.body.addEventListener('click', event => {
	const targetElement = event.target;
	if (!targetElement.closest('.masthead__wrapper')) {
		document.querySelectorAll(".on").forEach(
			(ele) => ele.classList.remove("on")
		)
	}
});

// roll off into iframe
const iframe = document.querySelector("iframe");
if (iframe) iframe.addEventListener(
	"mouseenter",
	() => document.querySelectorAll(".on").forEach(
		ele => ele.classList.remove("on")
	)
);
